import { useEffect, useState } from 'react';

const ToastAlert = ({ message, type = 'success', duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  const bgColor = type === 'success' ? 'bg-green-500/90' : 'bg-red-500/90';
  const borderColor = type === 'success' ? 'border-green-400' : 'border-red-400';

  return (
    <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in-up">
      <div className={`${bgColor} ${borderColor} border rounded-xl shadow-2xl p-4 min-w-[320px] backdrop-blur-sm`}>
        <div className="flex items-center gap-3">
          {type === 'success' ? (
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          )}
          <p className="text-white font-medium">{message}</p>
        </div>
        <div className="absolute bottom-0 left-0 h-1 bg-white/30 rounded-b-xl animate-progress" style={{ width: '100%', animationDuration: `${duration}ms` }} />
      </div>
    </div>
  );
};

export default ToastAlert;